<template>
    <div v-if="widgetReady" class="overflow-settings">
        <div class="table-container">
            <div class="row" v-if="!readOnly">
                <div class="col-sm-12">
                    <h5 style="text-align:center">{{relationship}}</h5>
                </div>
            </div>
            <table class="table table-sm" style="margin-bottom: 0px;">
                <thead>
                    <th v-if="readOnly">
                        <span>Relationship</span>
                    </th>
                    <th>
                        <span>Min-Max Age</span>
                    </th>
                    <th>
                        <span>Price</span>
                        <i data-toggle="tooltip" data-html="true" title="<div style='max-width:330px;position:relative;overflow:auto;'>
                            <div style='width:150px;float:left;text-align:left;padding-left:5px;'>Accresa transaction fees may apply</div></div>"
                            data-placement="right" class="fas fa-info-circle wl-color"></i>
                    </th>
                    <th>
                        <span></span>
                    </th>
                </thead>
                <tbody>
                    <!--Empty tr and tds to get the hr under the table headers when nothing to display-->
                    <template v-if="priceTiers.length ===0 && !readOnly">
                        <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </template>
                    <template v-if="priceTiers.length > 0 && !readOnly">
                        <tr v-for="(pt, index) in this.priceTiers" :key="index">
                            <td>
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-addon">#</div>
                                        <input type="text" class="form-control age" v-model="pt.minAge" :disabled="pt.endDate != null || Boolean(pt.futureSettings)">
                                        <label style="font-size: large; padding-top:3px"> - </label>
                                        <input type="text" class="form-control age" v-model="pt.maxAge" :disabled="pt.endDate != null || Boolean(pt.futureSettings)">
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="form-group">
                                    <div class="input-group">
                                        <div class="input-group-addon">$</div>
                                        <input type="text" class="form-control price" v-model="pt.price" :disabled="pt.endDate != null || Boolean(pt.futureSettings)">
                                    </div>
                                </div>
                            </td>
                            <td>
                                <button v-if="pt.priceTierId == 0" class="btn btn-xs btn-red" style="line-height:normal;" title="Remove New Price Tier" @click.prevent="()=>{deleteTempPriceTier(index)}"><i class="fa fa-minus-circle"></i></button>
                                <button v-if="pt.exist && pt.endDate == null && pt.priceTierId != 0 && !pt.futureSettings" class="btn btn-xs btn-red" style="line-height:normal;" title="Delete Existing Price Tier" @click.prevent="()=>{deleteExistingPriceTier(index)}"><i class="fa fa-trash"></i></button>
                                <button v-if="pt.exist && pt.endDate!= null && pt.priceTierId != 0" class="btn btn-xs btn-green" style="line-height:normal;" title="Restore Deleted Price Tier" @click.prevent="()=>{cancelDeleteExistingPriceTier(index)}"><i class="fa fa-trash-restore"></i></button>
                                <div class="future-settings-container" v-if="pt.futureSettings">
                                    <div class="pending-link">
                                        <div class="future-price-tier">
                                            <future-price-tier :future-settings="viewFuturePriceTier(pt)"></future-price-tier>
                                        </div>
                                        <span class="label label-warning"><i class="fa fa-question-circle"></i></span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
                <tbody>
                    <template v-if="readOnly">
                        <tr v-for="(p, index) in priceTiers" :key="index">
                            <td>
                                {{ p.relationship }}
                            </td>
                            <td>
                                {{p.minAge}} - {{p.maxAge}}
                            </td>
                            <td>
                                {{ p.price | currency }}
                            </td>
                            <td class="tier-button-content">
                                <div class="future-settings-container" v-if="Boolean(p.futureSettings)">
                                    <div class="pending-link">
                                        <div class="future-price-tier">
                                            <future-price-tier :future-settings="viewFuturePriceTier(p)"></future-price-tier>
                                        </div>
                                        <span class="label label-warning">View Pending Change</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
            <div class="row" v-if="!readOnly">
                <br>
                <div class="col-sm-12" style="text-align:center">
                    <button class="btn btn btn-green" style="padding:1px; font-size:small; font-weight: 400;" @click.prevent="addPriceTier">CREATE {{relationship}} PRICE TIER</button>
                </div>
            </div>
            <div class="row">
                <div v-if="anyIncompleteRows && showIncompleteAlert" class="col-md-12">
                    <div class="alert alert-danger" style="margin-bottom: 0; margin-top:6px;">
                        There are some price tiers that are not done being edited or added.
                        Please finish making changes to continue and save all price tiers.
                    </div>
                </div>
            </div>
            <div class="margin-top-15" v-if="futureOnlyPriceTiers.length > 0">
                <div v-for="future in futureOnlyPriceTiers">
                    <div class="alert alert-info">
                        New Price Tier: Begins on {{ future.effectiveDate | shortDate }}
                        with an age range of {{ future.minAge }}-{{ future.maxAge }}
                        at {{ future.price | currency }}
                    </div>
                </div>
            </div>
            <div class="margin-top-15" v-if="deletedOnlyPriceTiers.length > 0">
                <div v-for="deleted in deletedOnlyPriceTiers">
                    <div class="alert alert-info">
                        Deleted Price Tier: Ends on {{ deleted.endDate | shortDate }}
                        with an age range of {{ deleted.minAge }}-{{ deleted.maxAge }}
                        at {{ deleted.price | currency }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {api} from "../../../../../global/framework/api.js";
    import {notifications} from "../../../../../global/notifications.js";
    import {common} from "../../../../../global/common.js";
    import {formatter} from "../../../../../global/formatter.js";
    import FuturePriceTier from "./FuturePriceTier.vue";

    export default {
        name: "PriceTiers",
        components: {FuturePriceTier},
        props: {
            planId: {type: [Number], required: false, default: 0},
            consumerRelationshipId: {type: [Number], required: false, default: 0},
            readOnly: {type: [Boolean], required: false, default: false},
        },
        data() {
            return {
                priceTiers: [],
                priceTierTemplate: {},
                widgetReady: false,
                currentPriceTiers: [],
                futureOnlyPriceTiers: [],
                deletedOnlyPriceTiers: [],
                hasPatients: false,
                template: {},
                futureSettings: {},
                showIncompleteAlert: false,
            }
        },
        computed: {
            relationship() {
                return common.RELATIONSHIP_TYPE[this.consumerRelationshipId];
            },
            anyIncompleteRows() {
                for(let pt of this.priceTiers){
                    //MaxAge must be truthy but minAge and price could be zero (a zero price is not allowed via business rules)
                    if(!pt.maxAge || pt.price === '' || pt.minAge === ''){
                        return true;
                    }
                }
                return false
            }
        },
        methods: {
            async addPriceTier() {
                var newPriceTier = {
                    ...(this.clone(this.priceTierTemplate)),
                    modified: true,
                    exist: false                
                }
                newPriceTier.consumerRelationshipId = this.consumerRelationshipId;

                this.priceTiers.push(newPriceTier);
            },
            async deleteTempPriceTier(index) {    
                this.priceTiers.splice(index, 1);          
            },
            async deleteExistingPriceTier(index) {
                this.priceTiers[index].endDate = formatter.getTodaysDate();
            },
            async cancelDeleteExistingPriceTier(index){
                this.priceTiers[index].endDate = null
            },
            getPriceTiers() {
                return this.priceTiers;
            },
            viewFuturePriceTier(priceTier) {
                let futureSettings = {...priceTier.futureSettings, effectiveDate: priceTier.futureSettings.effectiveDate};
                return futureSettings;
            },
            relationshipMethod(obj) {
                return common.RELATIONSHIP_TYPE[obj];
            },
        },
        async mounted() {
            let [template] = await Promise.all([
                api.getNoId('PriceTier', 'EmptyPriceTier')
            ]);

            if (this.planId != 0) {
                let data = await api.get('PriceTier', this.planId, '');
                this.mapData('currentPriceTiers', data.current);
                var futureOnly = data.futureOnly;
                var deleteOnly = data.deletedOnly;
                this.hasPatients = data.hasPatients;

                Object.keys(this.currentPriceTiers).forEach(key => {
                    let p = data.current[key];
                    p.exist = true;
                    let obj = this.priceTiers.find(o => o.priceTierId === p.priceTierId);
                    if(this.consumerRelationshipId != 0){
                        if (obj == undefined && p.consumerRelationshipId === this.consumerRelationshipId) {
                            this.priceTiers.push(p)
                        }
                    }
                    else
                    {   
                        p.relationship = this.relationshipMethod(p.consumerRelationshipId);
                        this.priceTiers.push(p);
                    }
                })

                for(let pt of deleteOnly){
                    if(pt.consumerRelationshipId === this.consumerRelationshipId){
                        this.deletedOnlyPriceTiers.push(pt);
                    }
                }

                for(let pt of futureOnly){
                    if(pt.consumerRelationshipId === this.consumerRelationshipId){
                        this.futureOnlyPriceTiers.push(pt);
                    }
                }

                if(this.consumerRelationshipId == 0) { this.priceTiers.sort(function(a, b) { return a.consumerRelationshipId - b.consumerRelationshipId;}); }          
            }
            //Don't prepopulate controls, easier for user to enter data without having to delete prepopulated zeros
            template.minAge='';
            template.maxAge='';
            template.price='';
            this.mapData('priceTierTemplate', template);
            //activate tooltip
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            });
            this.widgetReady = true;
        },
    }
</script>

<style scoped>
    .deleted,
    button[disabled],
    button[disabled]:hover,
    button[disabled]:focus {
        opacity: .5;
    }

    .btn-red {
        border-width: 1px;
    }

    .margin-top-15 {
        margin-top: 15px;
    }

    /deep/ .tooltip {
        z-index: 100;
    }

    .future-settings-container {
        position: relative;
        width: 25px;
    }

    .future-price-tier {
        display: none;
    }

    .pending-link {
        cursor: pointer;
    }

    .pending-link:hover .future-price-tier {
        display: initial;
    }

    .table-container {
        max-width: 900px;
    }

    .overflow-settings {
        overflow: visible;
        margin: 1px;
    }

    @media (max-width: 520px) {
        .overflow-settings {
            overflow: auto;
        }
    }

    th, td {
        padding:5px;
    }

    .table > tbody > tr > td{
        padding: 4px;
    }

    .form-group {
        width:33%;
        margin-bottom: 0px;
    }

    .age {
        width:30px;
        padding:3px;
    }

    .price {
        width: 40px;
        padding:3px;
    }

    .input-group{
        display:flex;
        line-height: 1;
    }

    .input-group-addon{
        padding-left:2px;
        padding-right:10px;
    }

    .form-control {
        height: 30px;
    }

    .btn-green,
    .btn-green:hover,
    .btn-green:focus,
    .btn-green:active {
        border: 1px solid #2a9a71;
        color:white;
    }
</style>